const childrenLoaded = require('@alexspirgel/children-loaded');

class ComponentSpotlight extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}

		this.initializeAccordion();

		this.initialized = true;

	}

	initializeAccordion() {
		new AceAccordion ({
			selectors: {
				accordion: '.component-spotlight-accordion__items', // {string} Custom accordion element selector.
				item: '.component-accordion__item', // {string} Custom item element selector.
				heading: '.component-accordion__item-heading', // {string} Custom heading element selector.
				content: '.component-accordion__item-content', // {string} Custom content element selector.
				content_inner: '.component-accordion__item-content-inner' // {string} Custom content inner element selector.
			}
		});
	}

}

customElements.define('component-spotlight', ComponentSpotlight, {extends: 'div'});